"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatShortDate = formatShortDate;
exports.formatNumber = formatNumber;
exports.formatPercent = formatPercent; // Format any date

function formatShortDate(dateString) {
  return dateString && new Date(dateString).toLocaleDateString(undefined, {
    month: 'numeric',
    year: '2-digit'
  });
} // Format any number


function formatNumber(number) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return number !== null ? parseFloat(number).toFixed(decimals) : '-';
} // Format any number as a percent


function formatPercent(number) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var showPercent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return number !== null ? parseFloat(number * 100).toFixed(decimals) + (showPercent ? "%" : '') : '-';
}